import { connect } from 'react-redux';
import CargaCartao from './cargaCartao';

export default connect()(CargaCartao);
